<template>
  <div>
    <div class="main-header">
      <div class="logo">
        <img src="http://gull.ui-lib.com/purple/./assets/images/logo-white.png" alt="" style="">
      </div>


      <div class="menu-toggle" v-on:click="menu">
        <div></div>
        <div></div>
        <div></div>
      </div>


      <!--div class="d-flex align-items-center">
        <div class="search-bar ml-20">
          <input placeholder="Search" type="text"><i class="search-icon text-muted i-Magnifi-Glass1"></i>
        </div>
      </div-->


      <div style="margin: auto"></div>

      <div class="header-part-right">

        <!-- Full screen toggle -->


        <router-link to="/ayarlar"><i class="i-Data-Settings header-icon d-none d-sm-inline-block"></i></router-link>
        <!-- Grid menu Dropdown -->


        <div class="dropdown">

          <div class="user col align-self-end">

            <el-tooltip class="item" effect="dark" :content="$t('dilsec')" placement="right">
              <i class="i-Gear text-muted header-icon dropdown-toggle"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
            </el-tooltip>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dil" x-placement="bottom-end">
              <div class="menu-icon-grid">
                <el-select v-model="value" v-on:change="dil" filterable placeholder="Select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

              </div>
            </div>
          </div>
        </div>

        <!--div class="dropdown">
          <div class="badge-top-container" role="button" id="dropdownNotification" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">
            <span class="badge badge-primary">3</span>
            <i class="i-Bell text-muted header-icon"></i>
          </div>

          <div class="dropdown-menu dropdown-menu-right notification-dropdown rtl-ps-none ps"
               aria-labelledby="dropdownNotification" data-perfect-scrollbar="" data-suppress-scroll-x="true"
               x-placement="bottom-end"
               style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-253px, 36px, 0px);">
            <div class="dropdown-item d-flex" v-for="item in notifications">
              <div class="notification-icon">
                <i class="i-Speach-Bubble-6 text-primary mr-1"></i>
              </div>
              <div class="notification-details flex-grow-1" >
                <p class="m-0 d-flex align-items-center">
                  <span>New message</span>
                  <span class="badge badge-pill badge-primary ml-1 mr-1">new</span>
                  <span class="flex-grow-1"></span>
                  <span class="text-small text-muted ml-auto">10 sec ago</span>
                </p>
                <p class="text-small text-muted m-0">{{item}}</p>
              </div>
            </div>


            <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
              <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
            </div>
            <div class="ps__rail-y" style="top: 0px; right: 0px;">
              <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
            </div>
          </div>
        </div>


        <a-- href="javascript:void(0)" @click="setNotifications"> set 25</a-->


        <div class="dropdown">

          <div class="user col align-self-end">{{this.$store.state.KullaniciAdi}}
            <img src="./../assets/avatar.svg" id="userDropdown" alt="" data-toggle="dropdown"
                 aria-haspopup="true" aria-expanded="false">

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown" x-placement="bottom-end"
                 style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-15px, 36px, 0px);">
              <div class="dropdown-header">
                <i class="i-Lock-User mr-1"></i>
                {{this.$store.state.KullaniciAdi}}
              </div>
              <!--a class="dropdown-item">Hesabım</a-->

              <a class="dropdown-item"
                 @click.prevent="CikisYap">{{$t("cikis")}}</a>
            </div>
          </div>
        </div>


      </div>

      <!--el-select v-model="value" v-on:change="dil" filterable placeholder="Select">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select-->


    </div>


  </div>

</template>

<script>
    import notification from '../notification';

    export default {
        data() {
            return {
                options: [],
                value: ''
            }
        },
        computed: {
            notifications() {
                return notification.getters.getNotifications
            }
        },
        methods: {
            setNotifications() {
                notification.dispatch('setNotification', 25)
            },
            CikisYap() {
                this.$store.dispatch("logout")
            },
            dil() {
                this.$i18n.locale = this.value;
                this.options = this.$t('language');
                this.value = this.$i18n.locale;
                localStorage.setItem("language", this.$i18n.locale);
            },
            menu() {
                if ($("#sidebar-container")[0].className == 'sidebar-expanded open') {
                    $("#sidebar-container").removeClass("open");
                } else {
                    $("#sidebar-container").addClass("open");
                }
            },

            speak(CiuisVoiceNotification) {
                var synth = window.speechSynthesis;
                synth.cancel();
                var s = new SpeechSynthesisUtterance();
                s.volume = 0.5;
                s.rate = 1;
                s.pitch = 1;
                s.lang = this.$i18n.locale;
                s.text = CiuisVoiceNotification;
                synth.speak(s);


            },

        },
        created() {
            this.options = this.$t('language');
            this.value = localStorage.getItem('language');

            if(!localStorage.getItem('SBildirim')) {

              this.speak(this.$t("message") + this.$store.state.KullaniciAdi + ","+this.$t("message1"));
              this.$notify({
                title: this.$t("message1"),
                dangerouslyUseHTMLString: true,
                message: this.$store.state.KullaniciAdi,
              });

              localStorage.setItem("SBildirim","OK");
            }

        }
    }


</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/Doc/Header.vue